export { IconBlobExtended } from './IconBlobExtended'
export { IconBlobTypeExtended } from './types'
export type { IconBlobExtendedProps } from './types'
